import { render, staticRenderFns } from "./HsabPreferences.vue?vue&type=template&id=808ef18c&scoped=true"
import script from "./HsabPreferences.vue?vue&type=script&lang=ts"
export * from "./HsabPreferences.vue?vue&type=script&lang=ts"
import style0 from "./HsabPreferences.vue?vue&type=style&index=0&id=808ef18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808ef18c",
  null
  
)

export default component.exports